var map = {
	"./Control Panel-amico (1).png": "c2b7",
	"./Secure Server-amico (1).png": "6039",
	"./abnormal.png": "db16",
	"./breach.png": "2601",
	"./ddos.png": "dc51",
	"./deface.png": "5889",
	"./malware.png": "4ce3",
	"./password.png": "9895",
	"./phishing.png": "f7fa"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f7ce";